import React from 'react';

// Styles & Assets
import styles from './SelectorSimple.module.css';

// Interfaces
import { SelectorProps } from '../../../interfaces/Input';

const SelectorSimple: React.FC<SelectorProps> = ({ value, showOptions }) => {

    return (
        <div className={styles.simpleSelector}>
            <p>{value}</p>
            <div className={`${styles.triangle} ${showOptions ? styles.rotateTriangle : ''}`}></div>
        </div>
    );
};

export default SelectorSimple;